import { Reducer } from 'redux';
import { TransportadorasState, TransportadorasTypes } from './types';

const INITIAL_STATE: TransportadorasState = {
  data: [],
  error: false,
  loading: false,
  loadingCriaTransp: false,
  selecionada: undefined,
  transportadoraParceira: undefined,
  criarTransportadora: undefined,
  verificarTransportadora: [],
};

const reducer: Reducer<TransportadorasState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case TransportadorasTypes.LOAD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case TransportadorasTypes.LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        data: action.payload.data,
      };
    case TransportadorasTypes.LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        data: [],
      };
    case TransportadorasTypes.SELECT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case TransportadorasTypes.SELECT_SUCCESS:
      return {
        ...state,
        loading: false,
        selecionada: action.payload.selecionada,
      };
    case TransportadorasTypes.SELECT_TRANSPORTADORA_PARCEIRA_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case TransportadorasTypes.SELECT_TRANSPORTADORA_PARCEIRA_SUCCESS:
      return {
        ...state,
        loading: false,
        selecionada: action.payload.selecionada,
      };
    case TransportadorasTypes.CRIAR_TRANSPORT_REQUEST:
      return {
        ...state,
        loadingCriaTransp: true,
      };
    case TransportadorasTypes.CRIAR_TRANSPORT_SUCCESS:
      return {
        ...state,
        loadingCriaTransp: false,
        error: false,
        criarTransportadora: action.payload.criarTransportadora,
      };
    case TransportadorasTypes.CRIAR_TRANSPORT_FAILURE:
      return {
        ...state,
        loadingCriaTransp: false,
        error: true,
        criarTransportadora: undefined,
      };
    case TransportadorasTypes.VERIFICAR_TRANSPORT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case TransportadorasTypes.VERIFICAR_TRANSPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        verificarTransportadora: action.payload.verificarTransportadora,
      };
    case TransportadorasTypes.VERIFICAR_TRANSPORT_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        verificarTransportadora: [],
      };
    case TransportadorasTypes.CLEAR_TRANSP_SELECT:
      return {
        ...state,
        selecionada: undefined,
      };
    case TransportadorasTypes.CLEAN_SELECT:
      return INITIAL_STATE;
    default:
      return state;
  }
};

export default reducer;
